import { render, staticRenderFns } from "./TournamentCreate.vue?vue&type=template&id=7a6d5921&scoped=true&"
import script from "./TournamentCreate.vue?vue&type=script&lang=js&"
export * from "./TournamentCreate.vue?vue&type=script&lang=js&"
import style0 from "./TournamentCreate.vue?vue&type=style&index=0&id=7a6d5921&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6d5921",
  null
  
)

component.options.__file = "TournamentCreate.vue"
export default component.exports